<template>
    <div>
        <v-card>
            <v-card-title>
                My revisions
            </v-card-title>
            <v-card-text>

            </v-card-text>
        </v-card>
    </div>
</template>

<script>

import axios from '../axios-auth'

export default {
    data() {
        return {
            openedRevisionList: [],
        }
    },
    props:{ }
    ,    
    components: {
        
    },
    mounted() {
         this.initData()
    },
    methods : {
        initData() {
            // new revision with timer
            // opened revision 
            // finished revision

            const _data = {
                course_id: this.$route.params.course_id,
                rev_id: this.$route.params.rev_id
            }

            axios.post('/get-student-revision', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    console.log(res.data)

                    if (res.data.message !='OK') {
                        this.$store.commit('setFeedback', res.message) 
                        return
                    }
                    this.openedRevisionList = res.data.opened

            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })            
        },
        startRevision(_rev_id) {
            console.log(_rev_id)
        }
    }
}
</script>